import type { SVGProps } from 'react';

const SvgJpFontSizeLFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M2.05997 20.678C1.94997 20.524 1.99397 20.392 2.16997 20.326C6.98797 18.522 10.178 13.66 10.75 9.128H2.69797C2.52197 9.128 2.43397 9.04 2.43397 8.864V7.742C2.43397 7.566 2.52197 7.478 2.69797 7.478H10.838C10.882 5.74 10.882 3.98 10.882 2.264C10.882 2.088 10.97 2 11.146 2H12.4C12.576 2 12.664 2.088 12.664 2.264L12.62 7.478H20.914C21.09 7.478 21.178 7.566 21.178 7.742V8.864C21.178 9.04 21.09 9.128 20.914 9.128H12.752C13.698 13.968 17.108 18.214 21.442 20.216C21.596 20.282 21.64 20.414 21.53 20.568L20.694 21.756C20.584 21.888 20.474 21.91 20.32 21.844C16.338 19.732 13.258 16.146 11.894 11.944C10.64 15.882 7.62597 20.084 3.29197 21.954C3.13797 22.02 3.02797 21.976 2.93997 21.844L2.05997 20.678Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgJpFontSizeLFilled;
